import { Reducer as loginReducer } from 'modules/login';
import loginReducerMock from './reducers-mock/login.reducer.mock';

import { Reducer as languageReducer } from 'modules/language-provider';

import { Reducer as routerReducer } from 'modules/router';
import routerReducerMock from './reducers-mock/router.reducer.mock';

import { reducerKey as redemptionReducerKey } from '../modules/redemption/redemption.reducer';
import redemptionStatus from './reducers-mock/redemption.reducer.mock';

import { reducerKey as redemptionV2ReducerKey } from '../modules/redemption/v2/redemption.reducer';
import redemptionV2Status from './reducers-mock/redemptionV2.reducer.mock';

import { reducerKey as PYCRedeemReducerKey } from '../modules/pyc-redeem/pyc-redeem.reducer';
import { PYCRedeemReducer } from './reducers-mock/pyc-redeem.reducer.mock';

import { reducerKey as emailVerificationReducerKey } from 'modules/email-verification/email-verification.reducer';
import emailVerification from './reducers-mock/email-verification.reducer.mock';

import { Reducer as IPlocationReducer } from 'modules/IP-location';
import locationReducerMock from './reducers-mock/IPlocation.reducer.mock';

import { Reducer as loadingManagerReducer } from 'modules/loading-manager';
import loadingManagerReducerMock from './reducers-mock/loading-manager.reducer.mock';

const reducers = {
    [languageReducer.reducerKey]: languageReducer.default,
    [routerReducer.reducerKey]: routerReducerMock,
    [redemptionReducerKey]: redemptionStatus,
    [redemptionV2ReducerKey]: redemptionV2Status,
    [PYCRedeemReducerKey]: PYCRedeemReducer,
    [emailVerificationReducerKey]: emailVerification,
    [loginReducer.reducerKey]: loginReducerMock,
    [IPlocationReducer.reducerKey]: locationReducerMock,
    [loadingManagerReducer.reducerKey]: loadingManagerReducerMock
};

export default reducers;
